import { CSS } from "../../styles"

export const checkboxContainer = (): CSS => ({
  flexDirection: `column`,
  alignItems: `right`,
  width: `100%`,
})
